module.exports = __webpack_public_path__ + "img/add.1e71bac7.svg";